// extracted by mini-css-extract-plugin
export default {"root":"IconFinance_root__KM9Aa"};